import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="1" transform="matrix(1 0 0 -1 2.5 7)" fill="currentColor" className="line-fill" />
    <rect width="1" height="18" transform="matrix(1 0 0 -1 29.5 25)" fill="currentColor" className="line-fill" />
    <rect width="1" height="18" transform="matrix(1 0 0 -1 2.5 25)" fill="currentColor" className="line-fill" />
    <rect width="28" height="1" transform="matrix(1 0 0 -1 2.5 26)" fill="currentColor" className="line-fill" />
    <rect width="16" height="1" transform="matrix(1 0 0 -1 6.5 21)" fill="currentColor" className="text-fill" />
    <rect width="20" height="1" transform="matrix(1 0 0 -1 6.5 18)" fill="currentColor" className="line-fill" />
    <rect width="12" height="1" transform="matrix(1 0 0 -1 6.5 15)" fill="currentColor" className="text-fill" />
    <rect width="18" height="1" transform="matrix(1 0 0 -1 6.5 12)" fill="currentColor" className="line-fill" />
  </svg>,
  'ExternalPanelIcon'
);

export const ExternalPanelIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.text-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.line-fill': {
          color: theme.palette.status.success.main,
        },
      })}
    />
  );
};
